import { useTranslation } from 'react-i18next';

import { Field, FieldDescription, FieldLabel } from '@/components/ui/field';
import { Skeleton } from '@/components/ui/skeleton';

import { User } from '@/entities/layout';

interface UserInfoFieldProps {
  isLoading: boolean;
  user?: User;
}

export const UserInfoField = ({ isLoading, user }: UserInfoFieldProps) => {
  const { t } = useTranslation();

  return (
    <Field>
      <FieldLabel>{t('about.loggedInAs', 'Logged in as')}</FieldLabel>
      {isLoading ? (
        <Skeleton className="h-5 w-64" />
      ) : (
        <FieldDescription>
          {user?.name} - {user?.email}
        </FieldDescription>
      )}
    </Field>
  );
};
